import React from 'react';
import Container from 'react-bootstrap/esm/Container';

import { CommunicationTable } from '../Component/Communicationway/CommunicationTable';

export const CommunicationWayPage = () => {
  return (
    <Container style={{ marginTop: '50px' }}>
      <CommunicationTable />
    </Container>
  );
};
